<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle2" :subheading="subheading2"/>
      <div class="header-btn-box">
        <a @click="toModifyPage" v-if="permissionCodes.indexOf('006001001') !== -1">修改</a>
      </div>
    </div>

    <form>
      <div class="form-title">租金管理账户：</div>
      <div class="form-line">
        <div class="line-text">租金费收款账户名称：</div>
        <div>{{formData.rentRelateAliName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">租金费收款支付宝账号：</div>
        <div>{{formData.rentRelateAliCode || '无'}}</div>
      </div>
      <div class="form-title">物业管理账户：</div>
      <div class="form-line">
        <div class="line-text">物业费收款账户名称：</div>
        <div>{{formData.propertyRelateAliName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">物业费收款支付宝账号：</div>
        <div>{{formData.propertyRelateAliCode || '无'}}</div>
      </div>
      <div class="form-title">停车管理账户：</div>
      <div class="form-line">
        <div class="line-text">停车费收款账户名称：</div>
        <div>{{formData.yqRelateAliName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">停车费收款支付宝账号：</div>
        <div>{{formData.yqRelateAliCode || '无'}}</div>
      </div>
      <div class="form-title">电费管理账户：</div>
      <div class="form-line">
        <div class="line-text">电费收款账户名称：</div>
        <div>{{formData.electricRelateAliName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">电费收款支付宝账号：</div>
        <div>{{formData.electricRelateAliCode || '无'}}</div>
      </div>
      <div class="form-title">场地费管理账户：</div>
      <div class="form-line">
        <div class="line-text">场地费收款账户名称：</div>
        <div>{{formData.siteRelateAliName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">场地费收款支付宝账号：</div>
        <div>{{formData.siteRelateAliCode || '无'}}</div>
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import {api} from '../../api/PayService'
import {errorHandler} from '../../../utils/errorHandler'
import {bus} from '../../../utils/bus'

export default {
  components: {
    TextTitle,
    Breadcrumb},
  name: 'receiving-account-configuration',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '缴费服务',
        name: 'housing-management'
      }, {
        value: '收款账户配置'
      }],
      mainTitle2: '收款账户信息',
      subheading2: '园区收款账户信息配置',
      formData: {
        rentRelateAliName: '',
        rentRelateAliCode: '',
        propertyRelateAliName: '',
        propertyRelateAliCode: '',
        yqRelateAliName: '',
        yqRelateAliCode: '',
        electricRelateAliName: '',
        electricRelateAliCode: '',
        siteRelateAliName: '',
        siteRelateAliCode: ''
      }
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getYqAppInfo()
  },
  methods: {
    toModifyPage () {
      this.$router.push({
        name: 'receiving-account-modify'
      })
    },
    getYqAppInfo () {
      this.$axios.post(api.getPaySettingList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            data.map(v => {
              if (v.code === 'A001') {
                this.formData.rentRelateAliCode = v.relateAliNo
                this.formData.rentRelateAliName = v.relateAliName
              }
              if (v.code === 'A002') {
                this.formData.propertyRelateAliCode = v.relateAliNo
                this.formData.propertyRelateAliName = v.relateAliName
              }
              if (v.code === 'A003') {
                this.formData.yqRelateAliCode = v.relateAliNo
                this.formData.yqRelateAliName = v.relateAliName
              }
              if (v.code === 'A004') {
                this.formData.electricRelateAliCode = v.relateAliNo
                this.formData.electricRelateAliName = v.relateAliName
              }
              if (v.code === 'A005') {
                this.formData.siteRelateAliCode = v.relateAliNo
                this.formData.siteRelateAliName = v.relateAliName
              }
            })
          }
        })
        .catch(errorHandler('查询园区收款账户信息失败'))
    }
  }
}
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-title {
    color: #333333;
    font-size: 16px;
    line-height: 28px;
    padding-left: 5px;
    border-left: 3px solid #00a0e6;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 180px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/PayService/ReceivingAccountConfiguration/ReceivingAccountConfiguration.vue